import React from 'react';
import { cn } from '../../utils/cn';

const AlertDialogContext = React.createContext();

export function AlertDialog({ open, onOpenChange, children }) {
  return (
    <AlertDialogContext.Provider value={{ open, onOpenChange }}>
      {open && (
        <div className="fixed inset-0 z-[90] flex items-center justify-center">
          <div 
            className="fixed inset-0 bg-black/50" 
            onClick={() => onOpenChange?.(false)}
          />
          <div className="relative z-[91]">
            {children}
          </div>
        </div>
      )}
    </AlertDialogContext.Provider>
  );
}

export function AlertDialogContent({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'bg-white rounded-lg shadow-lg p-6 w-full max-w-md',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function AlertDialogHeader({ children, className, ...props }) {
  return (
    <div className={cn('mb-4', className)} {...props}>
      {children}
    </div>
  );
}

export function AlertDialogTitle({ children, className, ...props }) {
  return (
    <h2 className={cn('text-lg font-semibold text-slate-900', className)} {...props}>
      {children}
    </h2>
  );
}

export function AlertDialogDescription({ children, className, ...props }) {
  return (
    <p className={cn('text-sm text-slate-500 mt-2', className)} {...props}>
      {children}
    </p>
  );
}

export function AlertDialogFooter({ children, className, ...props }) {
  return (
    <div className={cn('flex justify-end gap-3 mt-6', className)} {...props}>
      {children}
    </div>
  );
}

export function AlertDialogAction({ children, className, onClick, ...props }) {
  return (
    <button
      className={cn(
        'px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export function AlertDialogCancel({ children, className, onClick, ...props }) {
  const { onOpenChange } = React.useContext(AlertDialogContext);
  
  return (
    <button
      className={cn(
        'px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors',
        className
      )}
      onClick={() => {
        onOpenChange?.(false);
        onClick?.();
      }}
      {...props}
    >
      {children}
    </button>
  );
}

